/**
 * Utility functions for working with node data
 */

/**
 * Converts various value types to boolean, handling string "false" correctly
 * @param {*} value - The value to convert to boolean
 * @returns {boolean} - The boolean representation
 */
function toBoolean(value) {
  // Handle null/undefined
  if (value == null) {
    return false
  }

  // Handle string values
  if (typeof value === 'string') {
    const lowerValue = value.toLowerCase().trim()
    return lowerValue !== 'false' && lowerValue !== '0' && lowerValue !== ''
  }

  // Handle all other types with standard boolean conversion
  return !!value
}

/**
 * Checks if a node has a network drive share
 * @param {Object} node - The node object with system_fields property
 * @returns {boolean} - True if the node has a network share, false otherwise
 */
export function hasNetworkShare(node) {
  if (!node || !node.system_fields) {
    return false
  }

  // Handle array format
  if (Array.isArray(node.system_fields)) {
    const networkShareField = node.system_fields.find(field =>
      field && typeof field === 'object' && 'has_network_share' in field
    )
    return networkShareField ? toBoolean(networkShareField.has_network_share) : false
  }

  // Handle object format
  if (typeof node.system_fields === 'object') {
    // Check if has_network_share is a direct property
    if ('has_network_share' in node.system_fields) {
      return toBoolean(node.system_fields.has_network_share)
    }

    // Check if any value in the object has has_network_share
    const networkShareField = Object.values(node.system_fields).find(field =>
      field && typeof field === 'object' && 'has_network_share' in field
    )
    return networkShareField ? toBoolean(networkShareField.has_network_share) : false
  }

  return false
}

export default {
  hasNetworkShare
}
